module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "testTubeEncyclopedia"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("试管百科")]), _vm._v(" "), _c('img', {
    staticClass: "testTubeicon",
    attrs: {
      "src": _vm.imgIcon
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "testTubeLogo",
    attrs: {
      "src": _vm.imgLogo
    }
  }), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": _vm.lookpage
    }
  }, [_c('em', [_vm._v("·")]), _vm._v(" 试管前")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('a', {
    on: {
      "click": _vm.lookpage
    }
  }, [_c('em', [_vm._v("·")]), _vm._v(" 取卵前")]), _c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.lookpage
    }
  }, [_c('em', [_vm._v("·")]), _vm._v(" 移植前")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": _vm.lookpage
    }
  }, [_c('em', [_vm._v("·")]), _vm._v(" 进周前")]), _c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.lookpage
    }
  }, [_c('em', [_vm._v("·")]), _vm._v(" 移植后")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": _vm.lookpage
    }
  }, [_c('em', [_vm._v("·")]), _vm._v(" 进周后")]), _c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.lookpage
    }
  }, [_c('em', [_vm._v("·")]), _vm._v(" 反复流产/失败")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.lookpage
    }
  }, [_c('em', [_vm._v("·")]), _vm._v(" 怀孕后")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a37e40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/testTubeEncyclopedia/TestTubeEncyclopediaIndex.vue
// module id = MWkm
// module chunks = 7